import React from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom'
import { PawPrint, Layers, MapPin, Home, ClipboardList, FileText, LayoutDashboard, Users } from 'lucide-react'

export default function Dashboard() {
    const { t } = useTranslation()

    return (
        <Container className='p-5'>
            <Row>
                <Col>
                    <div className='sd-label-dashboard'>{t('admin.dashboard.welcome')}</div>
                </Col>
            </Row>
            <Row className='mb-5'>
                <Col>
                    <h3>{t('admin.dashboard.subwelcome')}</h3>
                </Col>
            </Row>
            <Row>
                <Col xs={12} lg={4} className='my-3'>
                    <Link to={`/${t("url.admin.admin")}/${t("url.admin.users")}`} className='dashboard'>
                        <Card>
                            <Card.Body className='text-center'>
                                <Users size={64} className="me-2" />
                                <h2 className='noBold'>{t('menus.users')}</h2>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col xs={12} lg={4} className='my-3'>
                    <Link to={`/${t("url.admin.admin")}/${t("url.admin.templates")}`} className='dashboard'>
                        <Card>
                            <Card.Body className='text-center'>
                                <FileText size={64} className="me-2" />
                                <h2 className='noBold'>{t('menus.templates')}</h2>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col xs={12} lg={4} className='my-3'>
                    <Link to={`/${t("url.admin.admin")}/${t("url.admin.protocols")}`} className='dashboard'>
                        <Card>
                            <Card.Body className='text-center'>
                                <ClipboardList size={64} className="me-2" />
                                <h2 className='noBold'>{t('menus.protocols')}</h2>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
            </Row>
            <Row>
                <Col xs={12} lg={4} className='my-3'>
                    <Link to={`/${t("url.admin.admin")}/${t("url.admin.farms")}`} className='dashboard'>
                        <Card>
                            <Card.Body className='text-center'>
                                <Home size={64} className="me-2" />
                                <h2 className='noBold'>{t('menus.farms')}</h2>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col xs={12} lg={4} className='my-3'>
                    <Link to={`/${t("url.admin.admin")}/${t("url.admin.zones")}`} className='dashboard'>
                        <Card>
                            <Card.Body className='text-center'>
                                <MapPin size={64} className="me-2" />
                                <h2 className='noBold'>{t('menus.zones')}</h2>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col xs={12} lg={4} className='my-3'>
                    <Link to={`/${t("url.admin.admin")}/${t("url.admin.lots")}`} className='dashboard'>
                        <Card>
                            <Card.Body className='text-center'>
                                <Layers size={64} className="me-2" />
                                <h2 className='noBold'>{t('menus.lots')}</h2>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
            </Row>
            <Row>
                <Col xs={12} lg={4} className='my-3'>
                    <Link to={`/${t("url.admin.admin")}/${t("url.admin.animals")}`} className='dashboard'>
                        <Card>
                            <Card.Body className='text-center'>
                                <PawPrint size={64} className="me-2" />
                                <h2 className='noBold'>{t('menus.animals')}</h2>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
            </Row>
        </Container>
    )
}